import { render, staticRenderFns } from "./otherPosted.vue?vue&type=template&id=56e8620b&scoped=true"
import script from "./otherPosted.vue?vue&type=script&lang=js"
export * from "./otherPosted.vue?vue&type=script&lang=js"
import style0 from "./otherPosted.vue?vue&type=style&index=0&id=56e8620b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8620b",
  null
  
)

export default component.exports